import Logger from "../Logger";
import { showToast } from "../components/Toasts";
import ProductStorageHandler from "../persistence/ProductStorageHandle";
import { loadAndUploadTemplatesFromKnxProductDataFile, type SimpleProductInfo } from "./KnxprodLoader";
const logger = new Logger();

// Event listener and current uploadPercentage for setting Circular Progress bar
// while uploading .knxprod file to server -- at URL: /upload-productdata
var uploadPercentage: number = 0;
const listeners: any = [];

export function getUploadPercentage() {
  return uploadPercentage;
}

export function setUploadPercentage(value: number) {
  uploadPercentage = Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0;
  emitChangeEvent();
}

export function addChangeListener(listener: any) {
  listeners.push(listener);
}

export function removeChangeListener(listener: any) {
  const index = listeners.indexOf(listener);
  if (index !== -1) {
    listeners.splice(index, 1);
  }
}

function emitChangeEvent() {
  listeners.forEach((listener: any) => listener(uploadPercentage));
}

export async function uploadProductdataFilesToServer(files: any): Promise<SimpleProductInfo[]> {
  const uploadFiles = Array.from(files || []) as any[];
  if (uploadFiles.length == 0) return [];

  setUploadPercentage(1);
  const cachedMetadatas = await ProductStorageHandler.loadCachedAllMetadataAsObject("import");
  const allMetadatas = Array.isArray(cachedMetadatas) ? cachedMetadatas : [];
  const uploadedProducts: SimpleProductInfo[] = [];
  setUploadPercentage(5);

  const uploadStartPercentage = 5;
  const uploadRangePercentage = 95;

  if (uploadFiles) {
    for (let i = 0; i < uploadFiles.length; i++) {
      const fileStartPercentage = uploadStartPercentage + (i / uploadFiles.length) * uploadRangePercentage;
      const fileEndPercentage = uploadStartPercentage + ((i + 1) / uploadFiles.length) * uploadRangePercentage;
      const updateFileProgress = (filePercentage: number) => {
        const boundedFilePercentage = Number.isFinite(filePercentage) ? Math.max(0, Math.min(100, filePercentage)) : 0;
        setUploadPercentage(
          fileStartPercentage + ((fileEndPercentage - fileStartPercentage) * boundedFilePercentage) / 100,
        );
      };

      setUploadPercentage(fileStartPercentage);
      showToast({
        text: state
          .translate("UploadProductdataScreen.uploadingP1ofP2", "Uploading files $p1 of $p2")
          .replace("$p1", (i + 1).toString()) // no itx
          .replace("$p2", uploadFiles.length.toString()), // no itx
        keepVisible: true,
      });
      const file: any = uploadFiles[i];
      try {
        const productInfos = await loadAndUploadTemplatesFromKnxProductDataFile(
          file,
          true,
          allMetadatas,
          undefined,
          undefined,
          undefined,
          updateFileProgress,
        );
        uploadedProducts.push(...productInfos);
        setUploadPercentage(fileEndPercentage);
        showToast({ text: state.translate("UploadImageScreen.uploadComplete", "Upload Complete!") });
      } catch (ex: any) {
        logger.error(ex);
        // showToast({
        //   text: state.translate("knxprodLoader.errorWhileParsing", "An error occured while parsing product data."),
        //   isError: true,
        // });
        showToast({
          text: state.translate("UploadImageScreen.uploadError", "Upload error: $e").replace("$e", ex?.DATA || ""),
        }); // no itx
      }
    }
  }
  ProductStorageHandler.markAllMetadataCacheStale();
  setUploadPercentage(100);
  return uploadedProducts;
}
